// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-content[data-v-4d35644e] {
  padding-inline: var(--4d35644e-\\\$getStyles\\.paddingStandard);
  border-right: 1px solid var(--4d35644e-\\\$getStyles\\.rightBorderColor);
  height: calc(100vh - 67px) !important;
  position: relative;
}
.panel-header[data-v-4d35644e] {
  padding-top: var(--4d35644e-\\\$getStyles\\.paddingStandard);
  z-index: 1;
  background-color: var(--4d35644e-\\\$getStyles\\.backgroundColor);
}
.panel-header.sticky[data-v-4d35644e] {
  position: sticky;
  top: 0;
}
.clickable[data-v-4d35644e] {
  cursor: pointer;
}
[data-v-4d35644e] .i-tabs__content.col {
  height: var(--4d35644e-tabContentHeight) !important;
}
.panel-body-wrapper[data-v-4d35644e] {
  position: relative;
  overflow: hidden;
}
.panel-body[data-v-4d35644e] {
  position: absolute;
  width: 100%;
  height: 100%;
}
.slide-left-enter-active[data-v-4d35644e],
.slide-left-leave-active[data-v-4d35644e] {
  transition: all 0.3s ease;
}
.slide-left-enter-from[data-v-4d35644e] {
  transform: translateX(100%);
  opacity: 0;
}
.slide-left-enter-to[data-v-4d35644e] {
  transform: translateX(0%);
  opacity: 1;
}
.slide-left-leave-from[data-v-4d35644e] {
  transform: translateX(0%);
  opacity: 1;
}
.slide-left-leave-to[data-v-4d35644e] {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-right-enter-active[data-v-4d35644e],
.slide-right-leave-active[data-v-4d35644e] {
  transition: all 0.3s ease;
}
.slide-right-enter-from[data-v-4d35644e] {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-right-enter-to[data-v-4d35644e] {
  transform: translateX(0%);
  opacity: 1;
}
.slide-right-leave-from[data-v-4d35644e] {
  transform: translateX(0%);
  opacity: 1;
}
.slide-right-leave-to[data-v-4d35644e] {
  transform: translateX(100%);
  opacity: 0;
}
.panel-fade-enter-active[data-v-4d35644e],
.panel-fade-leave-active[data-v-4d35644e] {
  transition: opacity 0.15s ease-in-out;
}
.panel-fade-enter-from[data-v-4d35644e],
.panel-fade-leave-to[data-v-4d35644e] {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/create-dashboard/CreateLeftPanelTwo.vue","webpack://./CreateLeftPanelTwo.vue"],"names":[],"mappings":"AAEA;EACE,4DAAA;EACA,qEAAA;EACA,qCAAA;EACA,kBAAA;ACDF;ADIA;EACE,yDAAA;EACA,UAAA;EACA,8DAAA;ACDF;ADGE;EACE,gBAAA;EACA,MAAA;ACDJ;ADKA;EACE,eAAA;ACFF;ADKA;EACE,mDAAA;ACFF;ADKA;EACE,kBAAA;EACA,gBAAA;ACFF;ADKA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;ACFF;ADMA;;EAEE,yBAAA;ACHF;ADMA;EACE,2BAAA;EACA,UAAA;ACHF;ADMA;EACE,yBAAA;EACA,UAAA;ACHF;ADMA;EACE,yBAAA;EACA,UAAA;ACHF;ADMA;EACE,4BAAA;EACA,UAAA;ACHF;ADOA;;EAEE,yBAAA;ACJF;ADOA;EACE,4BAAA;EACA,UAAA;ACJF;ADOA;EACE,yBAAA;EACA,UAAA;ACJF;ADOA;EACE,yBAAA;EACA,UAAA;ACJF;ADOA;EACE,2BAAA;EACA,UAAA;ACJF;ADOA;;EAEE,qCAAA;ACJF;ADOA;;EAEE,UAAA;ACJF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.panel-content {\n  padding-inline: v-bind(\"$getStyles.paddingStandard\");\n  border-right: 1px solid v-bind(\"$getStyles.rightBorderColor\");\n  height: calc(100vh - 67px) !important;\n  position: relative;\n}\n\n.panel-header {\n  padding-top: v-bind(\"$getStyles.paddingStandard\");\n  z-index: 1;\n  background-color: v-bind(\"$getStyles.backgroundColor\");\n\n  &.sticky {\n    position: sticky;\n    top: 0;\n  }\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n:deep(.i-tabs__content.col) {\n  height: v-bind(tabContentHeight) !important;\n}\n\n.panel-body-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n\n.panel-body {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n// Slide from right to left\n.slide-left-enter-active,\n.slide-left-leave-active {\n  transition: all 0.3s ease;\n}\n\n.slide-left-enter-from {\n  transform: translateX(100%);\n  opacity: 0;\n}\n\n.slide-left-enter-to {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-left-leave-from {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-left-leave-to {\n  transform: translateX(-100%);\n  opacity: 0;\n}\n\n// Slide from left to right\n.slide-right-enter-active,\n.slide-right-leave-active {\n  transition: all 0.3s ease;\n}\n\n.slide-right-enter-from {\n  transform: translateX(-100%);\n  opacity: 0;\n}\n\n.slide-right-enter-to {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-right-leave-from {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-right-leave-to {\n  transform: translateX(100%);\n  opacity: 0;\n}\n\n.panel-fade-enter-active,\n.panel-fade-leave-active {\n  transition: opacity 0.15s ease-in-out;\n}\n\n.panel-fade-enter-from,\n.panel-fade-leave-to {\n  opacity: 0;\n}\n",".panel-content {\n  padding-inline: v-bind(\"$getStyles.paddingStandard\");\n  border-right: 1px solid v-bind(\"$getStyles.rightBorderColor\");\n  height: calc(100vh - 67px) !important;\n  position: relative;\n}\n\n.panel-header {\n  padding-top: v-bind(\"$getStyles.paddingStandard\");\n  z-index: 1;\n  background-color: v-bind(\"$getStyles.backgroundColor\");\n}\n.panel-header.sticky {\n  position: sticky;\n  top: 0;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n:deep(.i-tabs__content.col) {\n  height: v-bind(tabContentHeight) !important;\n}\n\n.panel-body-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n\n.panel-body {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.slide-left-enter-active,\n.slide-left-leave-active {\n  transition: all 0.3s ease;\n}\n\n.slide-left-enter-from {\n  transform: translateX(100%);\n  opacity: 0;\n}\n\n.slide-left-enter-to {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-left-leave-from {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-left-leave-to {\n  transform: translateX(-100%);\n  opacity: 0;\n}\n\n.slide-right-enter-active,\n.slide-right-leave-active {\n  transition: all 0.3s ease;\n}\n\n.slide-right-enter-from {\n  transform: translateX(-100%);\n  opacity: 0;\n}\n\n.slide-right-enter-to {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-right-leave-from {\n  transform: translateX(0%);\n  opacity: 1;\n}\n\n.slide-right-leave-to {\n  transform: translateX(100%);\n  opacity: 0;\n}\n\n.panel-fade-enter-active,\n.panel-fade-leave-active {\n  transition: opacity 0.15s ease-in-out;\n}\n\n.panel-fade-enter-from,\n.panel-fade-leave-to {\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
